import React from "react";
import { Box, FormControl, FormHelperText, InputLabel } from "@material-ui/core";

export const DetailWrapperOqt = ({caption, children, helperText = ""}) => {
  return (
    <div  style={{ margin: 8 }}>
      <FormControl fullWidth variant="standard" >
        <Box margin={0} >{children}{' '}</Box>
        {helperText &&
          <FormHelperText>{helperText}</FormHelperText>
        }
      </FormControl>
    </div>
  )

}
